<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.99967 1.33334C4.31967 1.33334 1.33301 4.32001 1.33301 8.00001C1.33301 11.68 4.31967 14.6667 7.99967 14.6667C11.6797 14.6667 14.6663 11.68 14.6663 8.00001C14.6663 4.32001 11.6797 1.33334 7.99967 1.33334ZM7.99967 11.3333C7.63301 11.3333 7.33301 11.0333 7.33301 10.6667V8.00001C7.33301 7.63334 7.63301 7.33334 7.99967 7.33334C8.36634 7.33334 8.66634 7.63334 8.66634 8.00001V10.6667C8.66634 11.0333 8.36634 11.3333 7.99967 11.3333ZM8.66634 6.00001H7.33301V4.66668H8.66634V6.00001Z"
      class="fill"
    />
  </svg>
</template>

<style lang="scss" scoped>
svg .fill {
  fill: #ffa800;
}

.text-blue svg .fill {
  fill: #417ce9;
}
</style>
